import React from 'react'
import { Flex } from 'reflexbox'

export default ({ children, ...props }) => (
  <Flex justifyContent="center" alignItems="center" {...props}>
    {children}
  </Flex>
)
